<template>
  <v-card width="auto" variant="text">
    <header-view></header-view>

    <div class="d-flex justify-center">
      <v-sheet width="350" class="bg-color">
        <v-img
          @contextmenu.prevent
          :src="this.NoImage"
          :lazy-src="this.NoImage"
          width="400"
        ></v-img>
        <p class="text-h6 font-weight-bold text-center">
          {{ $t("error.not-found") }}
        </p>
      </v-sheet>
    </div>

    <v-divider class="border-opacity-50 mt-4" thickness="2"></v-divider>

    <v-card-item>
      <card-footer></card-footer>
    </v-card-item>
  </v-card>
</template>

<script>
import NoProductImage from "@/assets/ilustration_no_product.svg";
import CardFooter from "@/components/footer/CardFooter.vue";
import HeaderView from "@/components/header/Header.vue";

export default {
  name: "NoProduct",

  components: {
    CardFooter,
    HeaderView,
  },

  data() {
    return {
      NoImage: NoProductImage,
    };
  },
};
</script>
